<template>
	<div class="information">
		<div class="created">{{ created }}</div>

		<div class="information-title mt-10 mb-10 sv-title">{{ title }}</div>

		<div class="information-body word-wrap" v-html="$utils.hyperlink(body)"></div>

		<div style="text-align: center;">
			<preview class="mt-10" :image="image" :maxH="200"></preview>
		</div>
	</div>
</template>

<style lang="scss" scoped>
@import '@/scss/_vars.scss';

.information {
	background: #fff;
	padding: 20px;

	.information-title {
		font-size: 26px;
	}

	.information-body {
		font-size: 18px;

		/deep/ a {
			&:hover,&:visited {
				color: #3273dc;
			}
		}
	}
}

</style>

<script>
import Preview from '@/components/Preview'

export default {
	name: 'Information',
	components: {
		Preview,
	},
	data () {
		return {
			title: '',
			body: '',
			image: '',
			created: '',
		}
	},
	created() {
	},
	mounted() {
		this.init();
	},
	computed: {
	},
	methods: {
		init: function() {
			this.getData();
		},
		getData: async function() {
			let loader = this.$buefy.loading.open();
			let ep = 'informations/' + this.$route.params.informationId;
			this.$utils.log(ep);

			try {
				let res = await this.$api.get(ep, null, true);
				this.$utils.log(res);
				this.title = res.data.title;
				this.body = res.data.body;
				this.image = res.data.image;
				this.created = res.data.created;
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
			} finally {
				loader.close();
			}
		},
	}
}
</script>
